
import { addSiteVisitor, getSiteVisitorCount, hasSiteSessionId } from "api/WebsiteApis/apis";

const VISIT_OK_KEY = "site_visit_sent";

const RETRY_DELAYS_MS = [0, 1500, 4000];

const VISIT_WAIT_MS = 8000;

let inflight = null;

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const readOkFlag = () => {
  try {
    return sessionStorage.getItem(VISIT_OK_KEY) === "1";
  } catch {
    return false;
  }
};

const writeOkFlag = () => {
  try {
    sessionStorage.setItem(VISIT_OK_KEY, "1");
  } catch {
  }
};

const isAccepted = (res) =>
  Boolean(res) &&
  typeof res === "object" &&
  (res.code === undefined || Number(res.code) < 500);

export const needsSiteVisit = () => !(readOkFlag() && hasSiteSessionId());

export const registerSiteVisit = () => {
  if (inflight) return inflight;
  if (!needsSiteVisit()) return Promise.resolve(true);

  const run = (async () => {
    for (const delay of RETRY_DELAYS_MS) {
      if (delay) await wait(delay);
      try {
        const res = await addSiteVisitor();
        if (isAccepted(res)) {
          writeOkFlag();
          return true;
        }
      } catch {
      }
    }
    return false;
  })();

  inflight = run.finally(() => {
    inflight = null;
  });
  return inflight;
};

const parseTodayCount = (res) => {
  const d = res?.data;
  const raw = d?.today_visitors ?? d?.todays_visitors ?? d?.today_count;
  const n = Number(raw);
  return raw != null && Number.isFinite(n) ? n : null;
};

const fetchTodayCount = async () => {
  for (let attempt = 0; attempt < 2; attempt += 1) {
    try {
      const n = parseTodayCount(await getSiteVisitorCount());
      if (n !== null) return n;
    } catch {

    }
    if (attempt === 0) await wait(1200);
  }
  return null;
};

const listeners = new Set();
let countFlowRunning = false;

const emit = (n) => listeners.forEach((fn) => fn(n));

const runCountFlow = async () => {
  const visit = registerSiteVisit();

  let visitDone = false;
  visit.then(() => {
    visitDone = true;
  });

  await Promise.race([visit, wait(VISIT_WAIT_MS)]);

  const first = await fetchTodayCount();
  if (first !== null) emit(first);

  if (!visitDone) {
    const recorded = await visit;
    if (recorded) {
      const second = await fetchTodayCount();
      if (second !== null) emit(second);
    }
  }
};

export const loadVisitorCount = (onValue) => {
  listeners.add(onValue);

  if (!countFlowRunning) {
    countFlowRunning = true;
    runCountFlow()
      .catch(() => {})
      .finally(() => {
        countFlowRunning = false;
      });
  }

  return () => {
    listeners.delete(onValue);
  };
};